import { RaThemeOptions, defaultDarkTheme, defaultLightTheme } from 'react-admin';

export const myRealStatLightTheme: RaThemeOptions = {
  ...defaultLightTheme,
  palette: {
    // mode: 'light' as 'light',
    primary: {
      //light: '#61747f',
      main: '#003d3f',
      //dark: '#13242e',
    },
    secondary: {
      //light:  '#ced1d1',
      main: '#4e5f7d',
      //dark: '#3d4e57',
    },
    background: {
      default: '#e3e9e9',
      paper: '#e9efef',

    },
  },
  components: {
    ...defaultLightTheme.components,
    RaMenuItemLink: {
      styleOverrides: {
        root: {
          borderBottom: '3px solid #fff',
          '&.RaMenuItemLink-active': {
            borderBottom: '3px solid #003d3f',
          },
        },
      },
    },
  },
  typography: {
    fontFamily: 'Garamond',
  },
};

export const myRealStatDarkTheme: RaThemeOptions = {
  ...defaultDarkTheme,
  palette: {
    mode: 'dark',
    primary: {
      main: '#FFFFFF',
    },
    secondary: {
      main: '#B9B2A8',
    },
    background: {
      default: '#000000',
      paper: '#000000',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#B3B3B3',
    },
  },
  shape: {
    borderRadius: 0,
  },
  components: {
    ...defaultDarkTheme.components,
    RaMenuItemLink: {
      styleOverrides: {
        root: {
          borderBottom: '3px solid #000',
          '&.RaMenuItemLink-active': {
            //borderBottom: '3px solid #B9B2A8',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorSecondary: {
          color: '#FFFFFF',
          backgroundColor: '#000000',
        },
      },
      
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "unset"
        }
      }
    }
  },
  typography: {
    fontFamily: 'Garamond',
    fontSize: 18,
  },
};
